const Sandbox = () => {
  return (
    <div className="flex s-full justify-center align-center font-36">
      Welcome to the Developer Sandbox!
    </div>
  );
};

export default Sandbox;
